import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { CASH_FUND_TAG_GRADIENT, CASH_FUND_TAG_BORDER } from './cashFund.constants';

// Gold diamond/gem glyph from the Figma tag (node 53294:11072).
const GemIcon = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13.5503 10.7838"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.3166 5.60563e-06C3.14951 5.83744e-06 2.99148 0.0759642 2.8871 0.206445L0.120508 3.66505C-0.0545455 3.88389 -0.0370656 4.19936 0.161095 4.39752L6.38624 10.6227C6.60103 10.8375 6.94927 10.8375 7.16406 10.6227L13.3892 4.39752C13.5874 4.19936 13.6048 3.8839 13.4298 3.66506L10.6633 0.206446C10.5589 0.0759608 10.4009 -1.89662e-07 10.2338 0C7.92807 1.86861e-06 5.62237 3.73733e-06 3.3166 5.60563e-06ZM7.36426 1.1L6.1861 1.1L5.11402 3.4586H8.43634L7.36426 1.1ZM9.64465 3.4586L8.57256 1.1L9.96942 1.1L11.856 3.4586H9.64465ZM8.46218 4.5586H5.08818L6.77518 8.56522L8.46218 4.5586ZM8.18896 8.04213L9.65571 4.5586H11.6725L8.18896 8.04213ZM1.69428 3.4586H3.90571L4.9778 1.1L3.58096 1.10001L1.69428 3.4586ZM5.36144 8.04223L3.89465 4.5586H1.87781L5.36144 8.04223Z"
      fill="#FFFFFF"
    />
  </svg>
);

// "Honeymoon Rate" pill shown on listings eligible for cash-fund pricing (Figma node 53294:11070).
// Gold gradient pill + gem glyph, positioned over the listing photo.
export const HoneymoonRateTag = () => {
  const { tq } = useTranslation('accommodationsConsole');
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      columnGap={1}
      paddingX="13px"
      paddingY="6px"
      borderRadius="999px"
      border={`1px solid ${CASH_FUND_TAG_BORDER}`}
      background={CASH_FUND_TAG_GRADIENT}
      boxShadow="0px 6px 3px rgba(0, 0, 0, 0.25)"
    >
      <GemIcon />
      <TextV2
        typographyVariant="label1"
        fontSize="10px"
        fontWeight={500}
        color="white"
        whiteSpace="nowrap"
        lineHeight={1.4}
      >
        {tq`Honeymoon Rate`}
      </TextV2>
    </Flex>
  );
};
